import { Button, Typography } from '@mui/material';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import Consultation from '/@/components/ask-an-expert/consultation';
import Link from '/@/components/link';
import { _ } from '/@/locale';
import { getAskAnExpertEnabled } from '/@/store/ask-an-expert/selectors';
import { reverse } from '/@/utils/router';
import Title from '/@/v3/components/title';
import Container from '../../components/container';
import styles from './styles.module.css';

@connect((state, props) => {
    return {
        dataField: props.dataField,
        enableAskAnExpert: getAskAnExpertEnabled(state),
    };
})
@autobind
export default class AskAnEspert extends Component {
    static propTypes = {
        enabled: PropTypes.bool,
    };

    static contextTypes = {
        history: PropTypes.object,
    };

    componentDidMount() {
        if (!this.props.enableAskAnExpert) return this.handleGoHome();
    }

    handleGoHome() {
        this.context.history(reverse('Home'));
    }

    renderHeader() {
        return (
            <div className={styles.goBack}>
                <Link className={styles.back} to='NewHome'>
                    <Typography sx={{ color: (t) => t.palette.primary.main }}>{_('Inicio')}</Typography>
                </Link>
            </div>
        );
    }

    renderTitle() {
        return (
            <div className={styles.title}>
                <Title size='xl' bolder className={styles.titleStyle}>
                    {_('Nueva consulta a un experto')}
                </Title>
            </div>
        );
    }

    renderConsult() {
        return <Consultation dataField={this.props.dataField} />;
    }

    render() {
        return (
            <Container backgroundColor='gray'>
                {this.renderHeader()}
                {this.renderTitle()}
                {this.renderConsult()}
            </Container>
        );
    }
}
